module.exports = __webpack_public_path__ + "static/media/header_image.937ef110.png";